import restore from "./restore"
const addMemo = (index) =>{
   restore("new memo","",index);
   
}

export default addMemo;